{
  "mode": "manual",
  "heading": "From the mats",
  "intro": "Training, tournaments and everyday team life — follow us on Instagram.",
  "posts": [
    {
      "image": "/images/from-the-mats/from-the-mats-01.webp",
      "permalink": "https://www.instagram.com/tiagobjjdepaula",
      "caption": "Team moments on the mats at Tiago de Paula BJJ."
    },
    {
      "image": "/images/from-the-mats/from-the-mats-02.webp",
      "permalink": "https://www.instagram.com/tiagobjjdepaula",
      "caption": "The next generation training together on the mats."
    },
    {
      "image": "/images/from-the-mats/from-the-mats-03.webp",
      "permalink": "https://www.instagram.com/tiagobjjdepaula",
      "caption": "One team, one community, one mat."
    }
  ]
}
